<div class="gl-dashboard__title">
  <span>{{ 'dashboard.comments' | translate }}</span>
</div>
<div *ngIf="!commentList || !commentList.length" class="gl-dashboard__item--void">
  <span>{{ 'dashboard.commentsVoid' | translate }}</span>
</div>
<div
  class="gl-dashboard__carousel"
  *ngFor="let comment of commentList; index as i; trackBy: trackByComment"
  [ngClass]="{ active: i === activeIndex }"
>
  <div class="gl-dashboard__comments--title">
    <span>{{ comment['gameName'] }}</span>
  </div>
  <div class="gl-dashboard__comments--text" title="{{ comment['comments'] }}">
    <span>{{ comment['comments'] }} </span>
  </div>
  <div class="gl-dashboard__comments--footer">
    <span class="gl-dashboard__comments--name" title="{{ comment['userName'] }}">{{ comment['userName'] }}</span>
    <span class="gl-dashboard__comments--date" title="{{ comment['created_at'] | date : 'dd/MM/yyyy' }}">{{
      comment['created_at'] | date : 'dd/MM/yyyy'
    }}</span>
    <div class="gl-dashboard__comments--navigation">
      <span
        class="glicon-left-arrow"
        [ngClass]="{ disabled: disabledArrows || activeIndex === 0 }"
        (click)="previous()"
      ></span>
      <span
        class="glicon-right-arrow"
        [ngClass]="{ disabled: disabledArrows || commentList.length - 1 === activeIndex }"
        (click)="next()"
      ></span>
    </div>
  </div>
</div>
